import { queryGetFieldAllowedValues } from '../Queries';


export default class Entity {
  static getFieldAllowedValues(staticFields, dynamicFields, requestedFields) {
    const staticFieldNames = Object.keys(staticFields);
    const dynamicFieldNames = Object.keys(dynamicFields);

    requestedFields = requestedFields || [ ...staticFieldNames, ...dynamicFieldNames ];

    return new Promise((resolve, reject) => {
      const staticFieldValues = {};
      const dynamicFieldValues = {};

      for (let field of requestedFields) {
        if (staticFieldNames.includes(field)) {
          staticFieldValues[field] = staticFields[field];
        }
      }

      if (requestedFields.some(field => dynamicFieldNames.includes(field))) {
        queryGetFieldAllowedValues(dynamicFields).then(response => {
          if (response.errors) {
            reject(response.errors.map(error => error.message));
            return;
          }

          for (let field of requestedFields) {
            if (response.data[field]) {
              dynamicFieldValues[field] = response.data[field];
            }
          }

          resolve({ ...staticFieldValues, ...dynamicFieldValues });
        }, error => {
          reject([error]);
        });
      }
      else {
        resolve(staticFieldValues);
      }
    });
  }
}
